<div  class="flex flex-column pb-4" [formGroup]="fg" >
  <div>
    <label class="text-sm text-color-secondary" [for]="inputFileFormControlName">Image du produit</label>

    <!--Button container prendre une photo-->
    <div class=" pt-4 flex justify-content-center">
      <p-button [outlined]="true" severity="info" label="Ajouter une photo" (click)="inputPhoto.click()"/>
    </div>

      <!-- Prise de photo -->
      <input
      #inputPhoto
      [formControlName]=inputFileFormControlName
      [id]="inputFileFormControlName"
      accept="image/*"
      type="file"
      (change)="loadPhoto($event)"
      style="display:none;" />

    <!--Preview de l'image selectionnée-->
    <div class="img__container">
      <ng-container class="" *ngIf="isFileSelected">
        <img [src]="previewFileFileBase64" alt="productImage.fileName">
      </ng-container>


      <!-- image par default -->
      <div *ngIf="fileTitle===''">
        <img src="image/image.svg" alt="productImage.fileName">
      </div>

      <!--tite du fichier-->
      <p>{{fileTitle}}</p>
    </div>

   <!--Message erreur-->
   <div *ngIf="fg.get(inputFileFormControlName)?.touched && fg.get(inputFileFormControlName)?.errors?.['required']">
    <p-message class="p-message" severity="error" text="La séléction de l'image est obligatoire" ></p-message>
  </div>
  </div>
</div>
